module.exports = __webpack_public_path__ + "static/media/Group 1570@3x.0c37d5bf.png";